
// ________________ HOME ________________
export function scrambleAnimation(startFontSize) {
    // ________________ SCRAMBLE ________________
    // _______ CLASS _______
    class ScrambleText {
        constructor(element) {
            this.element = element;
            this.height = this.element.clientHeight;
            this.modifiedFontSize = startFontSize;
            this.chars = '!<>-_\\/[]{}—=+*^?#10_______';
            this.update = this.update.bind(this);
        }
        setText(newText) {
            const oldText = this.element.innerText;
            const length = Math.max(oldText.length, newText.length)
            const promise = new Promise((resolve) => this.resolve = resolve);
            this.queue = [];
            for (let i = 0; i < length; i++) {
                const from = oldText[i] || '';
                const to = newText[i] || '';
                const start = Math.floor(Math.random() * 15);
                const end = start + Math.floor(Math.random() * 15);
                this.queue.push({from, to, start, end});
            }
            cancelAnimationFrame(this.frameRequest);
            this.frame = 0;
            this.update()

            return promise;
        }
        update() {
            let output = '';
            let complete = 0;
            for (let i = 0, n = this.queue.length; i < n; i++) {
                let {from, to, start, end, char} = this.queue[i];
                this.resizeText();
                if (this.frame >= end) {
                    complete++;
                    output += to;
                } else if (this.frame >= start) {
                    if (!char || Math.random() < 0.28) {
                        char = this.randomChar();
                        this.queue[i].char = char;
                    }
                    output += `<span class="scramble-letter">${char}</span>`;
                } else {
                    output += from;
                }
            }
            this.element.innerHTML = output;
            if (complete === this.queue.length) {
                this.lastOverflow = false;
                    this.resolve();
                } else {
                this.frameRequest = requestAnimationFrame(this.update);
                this.frame++;
            }
        }
        randomChar() {
            return this.chars[Math.floor(Math.random() * this.chars.length)]
        }
        isOverflow() {
            return this.element.scrollHeight > this.height + 5;
        }
        resizeText() {
            let overflow = this.isOverflow();
            if (overflow) {
                this.lastOverflow = true;
            }
            if (overflow || this.lastOverflow ) {
                while (overflow && this.modifiedFontSize > 16) {
                    this.modifiedFontSize--;
                    this.element.style.fontSize = `${this.modifiedFontSize}px`;
                    overflow = this.isOverflow();
                }
            } else {
                while (this.modifiedFontSize < startFontSize && !this.isOverflow()) {
                    this.modifiedFontSize++;
                    this.element.style.fontSize = `${this.modifiedFontSize}px`;
                }
            }
        }
    }
    // _______ STARTING SCRAMBLE _______
    const phrases = [
        "Développeuse", 
        "Étudiante",
        "Sherlock Holmes du code", 
        "Addicte aux chats"
    ]
    const scramble = () => {
        let counter = 0;
        const scrambleElement = document.querySelector('#scramble');
        const scrambleAnimation = new ScrambleText(scrambleElement);

        const nextScramble = () => {
            scrambleAnimation.setText(phrases[counter]).then(() => {
                setTimeout(nextScramble, 2000);
            })
            counter = (counter + 1) % phrases.length;
        }
        nextScramble();
    }

    scramble();
}

export function SVGAnimation(time, groups, foundGroup, getTransformOrigin, StartAnimation) {
    for (let group of groups) {
        setTimeout(() => {
            const groupElement = foundGroup(group.id);
            let delay = 0;
            groupElement.forEach(element => {
                delay += 200;
                getTransformOrigin(element);
                StartAnimation(element, delay);
            })
        }, time += group.time);
    }
}

